// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'contacts';

const Model = class Contact extends BaseModel {
  static modelName = 'Contact';

  static instanceDefaults() {
    return {
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
